import { render, staticRenderFns } from "./ActorFilter2.vue?vue&type=template&id=0a9b2599"
import script from "./ActorFilter2.vue?vue&type=script&lang=js"
export * from "./ActorFilter2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports